<div class="app-container">
    <app-header (changeLang)="useLanguage($event)"></app-header>
    <main>
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>